module.exports = __webpack_public_path__ + "static/img/8en.608d213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/8en.png
// module id = Wo1O
// module chunks = 0